/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Notify_Ev_DoneInputs */

const en_fw_notify_ev_done = /** @type {(inputs: Fw_Notify_Ev_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task done`)
};

const id_fw_notify_ev_done = /** @type {(inputs: Fw_Notify_Ev_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task selesai`)
};

/**
* | output |
* | --- |
* | "Task done" |
*
* @param {Fw_Notify_Ev_DoneInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_notify_ev_done = /** @type {((inputs?: Fw_Notify_Ev_DoneInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Notify_Ev_DoneInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_notify_ev_done(inputs)
	return en_fw_notify_ev_done(inputs)
});